module.exports = __webpack_public_path__ + "static/media/logo-varzeanova.f6130ee6.png";